module.exports = __webpack_public_path__ + "img/rangers_hall_small.31058bf0.png";